"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_interfaces_1 = require("dyna-interfaces");
exports.unknownError = function (code, section) { return ({
    section: section,
    code: code,
    errorType: dyna_interfaces_1.EErrorType.APP,
    message: "dyna-node: Unknown error [" + code + "]: Error caught but no details are available.",
}); };
//# sourceMappingURL=unknownError.js.map